import { Controller } from 'stimulus';
import throttle from '../helpers/throttle';

const OFFSET = 100;

/**
 * Button to return to the top of the page
 *
 * @class ToTop
 * @extends {Controller}
 */
class ToTop extends Controller {
  connect() {
    this.throttledScroll = throttle(this.checkVisibility.bind(this), 150);
  }

  onScroll() {
    this.throttledScroll();
  }

  checkVisibility() {
    const top = document.documentElement.scrollTop;

    this.element.classList.toggle('is-active', top > OFFSET);
  }
}

ToTop.targets = [
  //
];

export default ToTop;
